import axios from 'axios';

let token = localStorage.getItem('token');

export default axios.create({
    baseURL: process.env.VUE_APP_BASE_HTTP,
    headers: { Accept: 'application/json', authorization: 'Bearer ' + token, 'Client-Id': 'jau' },
});
